'use strict';

// Assigned Dependencies
require('jquery-placeholder');

module.exports = (function() {    
    $('input, textarea').placeholder();    
    setupJSLinks();
    setupBlockQuotes();

    $('.flip-on-active').click(function() {        
        $(this).toggleClass('active');
        $(this).siblings('.flip-on-active-content').toggleClass('active');
    });

    $('.accordion-trigger-button').on('click', function(e){
        e.preventDefault();
        $(this).parents('.accordion-item').removeClass('active');
        $(this).parents('.accordion-item').find('.accordion-content').removeClass('active');
        var next =$(this).parents('.accordion-item').next();
        $(next).addClass('active');
        $(next).find('.accordion-content').addClass('active');
        $(next).find('input:first').focus();
    });

    window.setupVideoModules = function() {
        setupVideoModules();
    };

    $('.to-top').click(function(e) {
        e.preventDefault();        
        $('html, body').animate({
            scrollTop: 0
        },800); 
    });

    window.moveWindowToElement = function(element, offsetMinus, speed) {
        if ($(element).length > 0) {
            var offset = $(element).offset().top - offsetMinus;      
            $('html, body').animate({
                scrollTop: offset
            },speed); 
        }
    };

    window.getHashParams = function() {
        return getHashParams();
    };

    global.isPrototype = function() {
        var isProto = $("meta[name='is-prototype']");
        var result = false;
        if ($(isProto).length > 0) {
            result = $(isProto).attr('content') == "true";   
        }

        return result;
    };

})();

function setupJSLinks() {
    $('.jsLink').click(function() {
        var link = $(this);

        if (typeof($(link).attr('data-href')) !== 'undefined' && $(link).attr('data-href').length > 0) {
            if (typeof($(this).attr('data-target')) !== 'undefined' && $(link).attr('data-target') == '_blank') {
                window.open($(link).attr('data-href'));
            } else {
                window.location = $(link).attr('data-href');
            }
        }
    });
}

function getHashParams() {

    var hashParams = {};
    var e,
        a = /\+/g,  // Regex for replacing addition symbol with a space
        r = /([^&;=]+)=?([^&;]*)/g,
        d = function (s) { return decodeURIComponent(s.replace(a, " ")); },
        q = window.location.hash.substring(1);

    while (e = r.exec(q))
       hashParams[d(e[1])] = d(e[2]);

    return hashParams;
}

function setupBlockQuotes() {
    $('blockquote').each(function() {        
        if ($(this).find('hr').length == 0) {
            $(this).append('<hr />').prepend('<hr />');
        }
    });  
}